export default {
      id: "big-minus-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#big-minus",
      toString: function () {
        return this.url;
      }
    }